import * as stylex from '@stylexjs/stylex';
import { useTranslation } from 'react-i18next';
import { containerStyles } from '../../styles/common';

const styles = stylex.create({
    container: {
        padding: '3rem 0',
        width: '100%',
    },
    heading: {
        fontSize: '2.5rem',
        marginBottom: '1.5rem',
        color: '#fff',
        textShadow: '0 2px 4px rgba(0,0,0,0.3)',
        fontWeight: 300,
        letterSpacing: '0.05em',
        fontFamily: "'Oswald', sans-serif",
        textAlign: 'center',
    },
    authorImage: {
        width: '200px',
        height: '200px',
        borderRadius: '50%',
        objectFit: 'cover',
        margin: '0 auto 2rem',
        display: 'block',
        boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        ':hover': {
            transform: 'scale(1.05)',
            boxShadow: '0 12px 32px rgba(0,0,0,0.6), 0 0 15px rgba(255, 120, 50, 0.3)',
        },
    },
    content: {
        fontSize: '1.1rem',
        lineHeight: 1.7,
        color: 'rgba(255, 255, 255, 0.8)',
        maxWidth: '600px',
        margin: '0 auto',
        textShadow: '0 1px 2px rgba(0,0,0,0.15)',
        textAlign: 'center',
        fontFamily: "'Montserrat', sans-serif",
    },
    socialLinks: {
        display: 'flex',
        justifyContent: 'center',
        gap: '1.5rem',
        marginTop: '2rem',
    },
    socialLink: {
        color: 'rgba(250, 248, 255, 0.8)',
        textDecoration: 'none',
        fontSize: '1rem',
        transition: 'color 0.3s ease',
        ':hover': {
            color: '#f8f6ff',
            textDecoration: 'underline',
        },
    },
});

export default function AboutAuthorSection() {
    const { t } = useTranslation();

    return (
        <div id="about-author" {...stylex.props(styles.container)}>
            <h2 {...stylex.props(styles.heading)}>{t('aboutAuthor.title')}</h2>

            <img
                src="/assets/profile-optimized.jpg"
                alt="Michał Rudol"
                {...stylex.props(styles.authorImage)}
            />

            <div {...stylex.props(containerStyles.simpleContainer)}>
                <p {...stylex.props(styles.content)}>
                    {t('aboutAuthor.bio')}
                </p>

                <div {...stylex.props(styles.socialLinks)}>
                    <a
                        href="https://rudol.me"
                        target="_blank"
                        rel="noopener noreferrer"
                        {...stylex.props(styles.socialLink)}
                    >
                        {t('aboutAuthor.website')}
                    </a>
                </div>
            </div>
        </div>
    );
} 